
/* Avena Cloud Pillow — buy box. Adds pillow + optional pillowcase as ONE cart/add.js call. */
(function () {
  var cfg = { adding: 'Adding\u2026', added: 'Added to your cart.', error: 'Something went wrong. Please try again.',
              added_fallback: 'Added. Open your cart to check out.', unavailable: 'Please choose a pack.' };
  function money(n) { return '$' + n.toFixed(2); }

  function initForm(form) {
    var cards = Array.prototype.slice.call(form.querySelectorAll('[data-acp-card]'));
    var status = form.querySelector('[data-acp-status]');
    var fallback = form.querySelector('[data-acp-fallback]');
    var button = form.querySelector('.acp-submit');
    var label = button.querySelector('span');
    var btotal = form.querySelector('[data-acp-btotal]');
    var sticky = document.querySelector('[data-acp-sticky]');
    var original = label.textContent;
    var pending = false;

    function selectedCard() {
      for (var i = 0; i < cards.length; i++) {
        var r = cards[i].querySelector('[name=id]');
        if (r && r.checked) return cards[i];
      }
      return null;
    }
    function packTotal(card) { return parseFloat(String(card.getAttribute('data-total')).replace('$', '')) || 0; }
    function caseInput(card) { return card.querySelector('[data-acp-case-input]'); }
    function caseOn(card) { var i = caseInput(card); return !!(i && i.checked); }
    function casePrice(card) {
      var i = caseInput(card);
      return parseFloat((i && i.getAttribute('data-case-price')) || card.getAttribute('data-case-price')) || 0;
    }
    function caseVariant(card) {
      var i = caseInput(card);
      return Number((i && i.getAttribute('data-case')) || card.getAttribute('data-case'));
    }

    function paint() {
      cards.forEach(function (c) {
        var r = c.querySelector('[name=id]');
        c.classList.toggle('is-sel', !!(r && r.checked));
      });
      var card = selectedCard();
      cards.forEach(function (c) {
        var row = c.querySelector('[data-acp-case-row]');
        if (row) row.classList.toggle('is-on', caseOn(c));
      });
      var on = !!(card && caseOn(card));
      var total = card ? packTotal(card) + (on ? casePrice(card) : 0) : 0;
      if (btotal) btotal.textContent = card ? money(total) : '';
      button.disabled = pending || !card;
      if (sticky && card) {
        var p = sticky.querySelector('[data-acp-stpack]');
        var pr = sticky.querySelector('[data-acp-stprice]');
        var im = sticky.querySelector('[data-acp-stimg]');
        var cim = card.querySelector('img');
        if (p) p.textContent = card.getAttribute('data-pack') + (on ? ' + pillowcase' : '');
        if (pr) pr.textContent = money(total);
        if (im && cim) im.src = cim.currentSrc || cim.src;
      }
    }
    form.addEventListener('change', paint);
    cards.forEach(function (c) {
      c.addEventListener('click', function () {
        var r = c.querySelector('[name=id]');
        if (r && !r.checked) { r.checked = true; }
        window.setTimeout(paint, 0);
      });
    });
    cards.forEach(function (c) {
      var row = c.querySelector('[data-acp-case-row]');
      if (!row) return;
      row.addEventListener('click', function (e) {
        // The row is a span inside the pack label, so there is no native checkbox toggle:
        // drive both the radio and the checkbox explicitly.
        e.preventDefault();
        e.stopPropagation();
        var r = c.querySelector('[name=id]');
        var i = caseInput(c);
        if (r && !r.checked) {
          // unselected card: one tap selects that pack AND includes its pillowcase
          r.checked = true;
          if (i) i.checked = true;
        } else if (i) {
          // already the selected card: the tap toggles its pillowcase
          i.checked = !i.checked;
        }
        window.setTimeout(paint, 0);
      });
    });
    paint();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (pending) return;
      var card = selectedCard();
      if (!card) { status.hidden = false; status.textContent = cfg.unavailable; return; }
      var pillowId = Number(card.querySelector('[name=id]').value);
      if (!Number.isSafeInteger(pillowId)) return;
      var items = [{ id: pillowId, quantity: 1 }];
      if (caseOn(card)) {
        var caseId = caseVariant(card);
        if (Number.isSafeInteger(caseId)) items.push({ id: caseId, quantity: 1 });
      }
      pending = true; paint();
      label.textContent = cfg.adding; status.hidden = true; fallback.hidden = true;
      button.setAttribute('aria-busy', 'true');
      var drawer = document.querySelector('cart-drawer');
      var added = false;
      var sections = (drawer && drawer.getSectionsToRender)
        ? drawer.getSectionsToRender().map(function (s) { return s.id; })
        : ['cart-drawer', 'cart-icon-bubble'];
      if (drawer && drawer.setActiveElement) { try { drawer.setActiveElement(button); } catch (err) {} }
      fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items, sections: sections, sections_url: location.pathname })
      }).then(function (r) {
        var ct = r.headers.get('content-type') || '';
        if (!/^(application\/json|text\/javascript)(;|$)/i.test(ct)) throw new Error(cfg.error);
        return r.json().then(function (data) {
          if (!r.ok || data.status >= 400) throw new Error(data.description || cfg.error);
          return data;
        });
      }).then(function (data) {
        added = true;
        var missing = sections.some(function (k) { return !(data.sections && data.sections[k]); });
        if (!drawer || !drawer.renderContents || missing) throw new Error(cfg.added_fallback);
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
        status.textContent = cfg.added;
      }).catch(function (error) {
        status.textContent = added ? cfg.added_fallback : (error.message || cfg.error);
        fallback.hidden = !added;
      }).then(function () {
        status.hidden = false; pending = false; label.textContent = original;
        button.removeAttribute('aria-busy'); paint();
      });
    });

    if (sticky) {
      var stbtn = sticky.querySelector('[data-acp-stbtn]');
      if (stbtn) stbtn.addEventListener('click', function () {
        form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
      var buy = document.getElementById('buy');
      var hero = document.querySelector('.acp-hero');
      var buyVisible = false, pastHero = false;
      function apply() { sticky.hidden = false; sticky.classList.toggle('is-on', pastHero && !buyVisible); }
      if ('IntersectionObserver' in window && buy && hero) {
        new IntersectionObserver(function (es) {
          es.forEach(function (x) { buyVisible = x.isIntersecting; }); apply();
        }, { threshold: 0 }).observe(buy);
        new IntersectionObserver(function (es) {
          es.forEach(function (x) { pastHero = !x.isIntersecting; }); apply();
        }, { threshold: 0 }).observe(hero);
      }
    }
  }

  function boot() {
    document.querySelectorAll('[data-acp-form]').forEach(initForm);
    var cartBtn = document.querySelector('[data-acp-cart]');
    if (cartBtn) cartBtn.addEventListener('click', function () {
      var d = document.querySelector('cart-drawer');
      if (d && d.open) d.open(); else window.location.href = '/cart';
    });
    var mid = document.querySelector('[data-acp-midbuy]');
    if (mid) {
      mid.addEventListener('click', function (e) {
        e.preventDefault();
        var two = document.querySelector('#buy [data-acp-card][data-qty="2"]');
        if (two) {
          var radio = two.querySelector('input[type="radio"]');
          if (radio && !radio.checked) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
          two.click();
        }
        var target = document.querySelector('#buy');
        if (target) {
          var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        }
      });
    }
    document.querySelectorAll('.acp a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = document.querySelector(a.getAttribute('href'));
        if (!t) return;
        e.preventDefault();
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
